import { InPlaceEditor } from '@syncfusion/ej2-inplace-editor';

import { confirmModal } from '@/front/modal';

export const initUnsavedChangesPrompt = (editor: InPlaceEditor) => {
  let initialValue: string | undefined;
  let prompting = false;

  editor.addEventListener('beginEdit', () => setTimeout(() => (initialValue = getPendingValue(editor)), 1));

  document.addEventListener('mousedown', async (event) => {
    if (!editor.enableEditMode || prompting || isInsideEditor(editor, event.target as HTMLElement)) return;

    if (getPendingValue(editor) === initialValue) {
      editor.enableEditMode = false;
      return;
    }

    prompting = true;
    const save = await confirmModal('Do you want to save your changes?', 'Save', 'primary', 'Discard');
    prompting = false;

    if (save) {
      editor.save();
    } else {
      editor.enableEditMode = false;
    }
  });
};

const isInsideEditor = (editor: InPlaceEditor, target: HTMLElement) =>
  editor.element.contains(target) ||
  !!target.closest('.e-editable-elements') ||
  target.classList.contains('e-chips-close');

const getPendingValue = (editor: InPlaceEditor) =>
  editor.type === 'MultiSelect'
    ? JSON.stringify(editor.multiSelectModule.compObj?.value)
    : editor.element.querySelector<HTMLInputElement | HTMLTextAreaElement>('.e-input')?.value;
